(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminAbsenceDisplaySettingsController', AdminAbsenceDisplaySettingsController);

    function AdminAbsenceDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'default_yearly_entitlement',
                'default_holiday_year_start_day',
                'default_holiday_year_start_month'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);
    }
})();
